<template>
  <div>
    <span class="fs-3">Mail Description Bundler</span>
    <div class="d-flex flex-column">
      <label for="mail-description-name">Title</label>
      <input id="mail-description-name" class="form-control" type="text" v-model="mailDescriptionTitle" placeholder="Title"/>
    </div>
    <div class="d-flex flex-column">
      <label for="mail-description-description">Message</label>
      <input id="mail-description-description" class="form-control" type="text" v-model="mailDescriptionMessage" placeholder="Message"/>
    </div>
    <div class="d-flex flex-column">
      <label for="mail-description-experience">Experience</label>
      <input id="mail-description-experience" class="form-control" type="number" v-model="mailDescriptionExperience" placeholder="Experience"/>
    </div>
    <div class="d-flex flex-column">
      <label for="mail-description-gold">Gold</label>
      <input id="mail-description-gold" class="form-control" type="number" v-model="mailDescriptionGold" placeholder="Gold"/>
    </div>
    <div class="position-relative border p-3 my-3">
      <div class="position-absolute top-0 left-0 translate-middle-y bg-white px-2">Equipment Rewards</div>
      <div class="d-flex gap-3">
        <button tooltip="Add Equipment Reward" class="btn btn-success" @click="increaseNum">
          <i class="fas fa-plus"></i>
        </button>

        <button class="btn btn-secondary" :class="`${equipmentRewards.length>=1?'':'disabled'}`" @click="decreaseNum">
          <i class="fas fa-minus"></i>
        </button>
      </div>
      <div class="d-flex gap-3 pt-2 flex-column">
        <div class="d-flex flex-row gap-3 reward_equipment_list" v-for="n, index of equipmentRewards" :key="index">
          <input
            type="text"
            class="form-control"
            :name="`equipment_${index}`"
            autocomplete="off"
            placeholder="Equipment"
            v-model="n.equipmentId"
            list="equipment_list"
            :id="`equipment_${index}`"
          />
          <input
            type="number"
            class="form-control"
            placeholder="Count"
            min="1"
            v-model="n.count"
            :name="`equipment_count_${index}`"
            :id="`equipment_count_${index}`"
          />
          <input
            type="number"
            class="form-control"
            placeholder="Duration"
            min="0"
            v-model="n.ttl"
            :name="`equipment_ttl_${index}`"
            :id="`equipment_ttl_${index}`"
          />
        </div>
      </div>
    </div>
    <div>
      <button class="btn btn-success" @click="MockSend">
        Send
      </button>
    </div>
    <datalist :id="`equipment_list`">
      <option
        :value="item.name"
        :data-id="item.id"
        v-for="item in store.custom.equipmentList"
        :key="item"
      >
        {{ item.name }}
      </option>
    </datalist>
  </div>
</template>

<script setup>
import { ref } from "vue";
import store from "node-back-client/src/store";

const mailDescriptionTitle = ref(null)
const mailDescriptionMessage = ref(null)
const mailDescriptionExperience = ref(null)
const mailDescriptionGold = ref(null)

const equipmentRewards = ref([
]);

const increaseNum = () => {
  equipmentRewards.value.push({ equipmentId: null, count: null, ttl: null })
};

const decreaseNum = () => {
  equipmentRewards.value.pop();
};

const MockSend = () => {

  const equipments = equipmentRewards.value.map(item => ({
    equipment: store.custom.equipmentList.find(x => x.name === item.equipmentId).id,
    count: item.count,
    ttl: parseInt(item.ttl),
    isExpiration: item.ttl > 0
  }));

  console.log("Data to send:", equipments);


  console.log("Payload:", 
  {
    name:mailDescriptionTitle.value,
    isDeleted:false,
    message:mailDescriptionMessage.value,
    reward:{
      equipments:equipments,
      exp:mailDescriptionExperience.value,
      gold:mailDescriptionGold.value
    }
  });

}


</script>

<style scoped></style>
